"use client"

import React, { useState, useEffect } from "react"
import api from "../config/api"
import { FiPlus, FiEdit2, FiTrash2 } from "react-icons/fi"

const Permissions = () => {
  const [permissions, setPermissions] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [selectedPerm, setSelectedPerm] = useState(null)
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  })
  const [error, setError] = useState("")

  useEffect(() => {
    loadPermissions()
  }, [])

  const loadPermissions = async () => {
    try {
      const response = await api.get("/permissions")
      setPermissions(response.data)
    } catch (error) {
      console.error("Yetkiler yüklenemedi:", error)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")

    try {
      if (selectedPerm) {
        await api.put(`/permissions/${selectedPerm.id}`, formData)
      } else {
        await api.post("/permissions", formData)
      }
      setShowModal(false)
      resetForm()
      loadPermissions()
    } catch (error) {
      setError(error.response?.data?.message || "İşlem başarısız")
    }
  }

  const handleDelete = async (id) => {
    if (!window.confirm("Bu yetkiyi silmek istediğinizden emin misiniz?")) return

    try {
      await api.delete(`/permissions/${id}`)
      loadPermissions()
    } catch (error) {
      alert("Silme işlemi başarısız")
    }
  }

  const handleEdit = (perm) => {
    setSelectedPerm(perm)
    setFormData({
      name: perm.name,
      description: perm.description || "",
    })
    setShowModal(true)
  }

  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
    })
    setSelectedPerm(null)
    setError("")
  }

  if (loading) {
    return React.createElement("div", { className: "loading" }, React.createElement("div", { className: "spinner" }))
  }

  return React.createElement(
    "div",
    { className: "permissions-page" },
    React.createElement(
      "div",
      { className: "page-header" },
      React.createElement("h1", null, "Yetki Yönetimi"),
      React.createElement(
        "button",
        {
          className: "btn btn-primary",
          onClick: () => {
            resetForm()
            setShowModal(true)
          },
        },
        React.createElement(FiPlus),
        "Yeni Yetki",
      ),
    ),
    React.createElement(
      "div",
      { className: "card" },
      React.createElement(
        "div",
        { className: "table-container" },
        React.createElement(
          "table",
          null,
          React.createElement(
            "thead",
            null,
            React.createElement(
              "tr",
              null,
              React.createElement("th", null, "ID"),
              React.createElement("th", null, "Yetki Adı"),
              React.createElement("th", null, "Açıklama"),
              React.createElement("th", null, "İşlemler"),
            ),
          ),
          React.createElement(
            "tbody",
            null,
            permissions.map((perm) =>
              React.createElement(
                "tr",
                { key: perm.id },
                React.createElement("td", null, perm.id),
                React.createElement("td", null, perm.name),
                React.createElement("td", null, perm.description || "-"),
                React.createElement(
                  "td",
                  null,
                  React.createElement(
                    "div",
                    { className: "action-buttons" },
                    React.createElement(
                      "button",
                      { className: "btn-icon", onClick: () => handleEdit(perm) },
                      React.createElement(FiEdit2),
                    ),
                    React.createElement(
                      "button",
                      { className: "btn-icon danger", onClick: () => handleDelete(perm.id) },
                      React.createElement(FiTrash2),
                    ),
                  ),
                ),
              ),
            ),
          ),
        ),
      ),
    ),
    showModal &&
      React.createElement(
        "div",
        { className: "modal-overlay", onClick: () => setShowModal(false) },
        React.createElement(
          "div",
          { className: "modal", onClick: (e) => e.stopPropagation() },
          React.createElement("h2", null, selectedPerm ? "Yetki Düzenle" : "Yeni Yetki"),
          error && React.createElement("div", { className: "error-message" }, error),
          React.createElement(
            "form",
            { onSubmit: handleSubmit },
            React.createElement(
              "div",
              { className: "input-group" },
              React.createElement("label", null, "Yetki Adı *"),
              React.createElement("input", {
                type: "text",
                value: formData.name,
                onChange: (e) => setFormData({ ...formData, name: e.target.value }),
                required: true,
              }),
            ),
            React.createElement(
              "div",
              { className: "input-group" },
              React.createElement("label", null, "Açıklama"),
              React.createElement("textarea", {
                value: formData.description,
                onChange: (e) => setFormData({ ...formData, description: e.target.value }),
              }),
            ),
            React.createElement(
              "div",
              { className: "modal-actions" },
              React.createElement(
                "button",
                { type: "button", className: "btn btn-secondary", onClick: () => setShowModal(false) },
                "İptal",
              ),
              React.createElement("button", { type: "submit", className: "btn btn-primary" }, "Kaydet"),
            ),
          ),
        ),
      ),
  )
}

export default Permissions
